import { useFormikContext } from "formik";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { InvoiceCustomerAddressComponents } from "./InvoiceCustomerAddressComponent";
import { initialCustomerValues } from "./InvoiceCustomerModal";

export const InvoiceCustomerAddress = ({
  isShipping,
  required,
}: {
  isShipping?: boolean;
  required?: boolean;
}) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const entityId = useCurrentEntityId();
  const { values, setFieldValue } = useFormikContext<
    typeof initialCustomerValues & {
      created_customer_id: string;
      shipping_same_as_billing: boolean;
      to_edit_address_id: string;
    }
  >();

  return (
    <div className="t-flex t-flex-col t-gap-3">
      <p className="t-m-0 t-text-subtitle">{isShipping ? "Ship" : "Bill"} to</p>
      <InvoiceCustomerAddressComponents
        required={required}
        formPrefix=""
        entityId={entityId}
        groupId={groupId}
        selectedAddressId={
          isShipping
            ? values?.shipping_address?.uuid
            : values?.billing_address?.uuid
        }
        label="Address"
        onAddressSelect={(address) => {
          setFieldValue(
            isShipping ? "shipping_address_id" : "billing_address_id",
            address?.uuid
          );
          setFieldValue(
            isShipping ? "shipping_address" : "billing_address",
            address
          );
        }}
        hideClear
        customerId={values?.created_customer_id}
        addressType={isShipping ? "SHIPPING" : "BILLING"}
        srollToSave
      />
    </div>
  );
};
